import { render, staticRenderFns } from "./EditWechat.vue?vue&type=template&id=29117c2f&scoped=true&"
import script from "./EditWechat.vue?vue&type=script&lang=js&"
export * from "./EditWechat.vue?vue&type=script&lang=js&"
import style0 from "./EditWechat.vue?vue&type=style&index=0&id=29117c2f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29117c2f",
  null
  
)

export default component.exports